import axios from "axios";

const baseURL = import.meta.env.VITE_API_URL_JS;

export const AuthKPI = async (data) => {
    const response = await axios.post(`${baseURL}/auth/kpi_user`, data);
    return response;
}